<template>
	<div class="contianer">
		<!-- 头部标题 -->
		<div class="header">
			<!-- <div class="header-retrun">&lt;</div>
			<div class="header-title">{{classes}}</div> -->
			<van-nav-bar left-text="返回" title="考试记录" left-arrow @click-left="onClickLeft()"/>
		</div>
		<!-- 间距 -->
		<div class="margin20"></div>
		<!-- 顶部搜索框 -->
		<div class="examRecord-top">
			<div class="examRecord-top_search">					
				<!-- <van-search placeholder="请输入您要搜索的内容" v-model="searchText" /> -->
				<van-search v-model="value" placeholder="请输入搜索关键词" show-action shape="round" @search="onSearch">
					<!-- <div slot="action" @click="onSearch">搜索</div> -->
					<div slot="action" class="examRecord-top_text"><van-icon  name="filter-o" />筛选</div>
				</van-search>
			</div>
		</div>
		<!-- 考试记录列表 -->
		<div class="examRecord">
			<div class="examRecord-box">
				<div class="examRecord-box_top">
					<div class="examRecord-box_title">
						<ul>
							<li>2018 考试真题题目</li>
						</ul>
					</div>
					<div class="examRecord-box_score">90分</div>
				</div>
				<div class="examRecord-box_bottom">
					<div class="examRecord-box_type">
						<div>练习时间：2：02：03</div>
						<div class="type-flex">练习类型：模型</div>
					</div>
					<div class="examRecord-box_see">查看详情</div>
				</div>
			</div>
			<!--  -->
			<div class="examRecord-box">
				<div class="examRecord-box_top">
					<div class="examRecord-box_title">
						<ul>
							<li>2018 考试真题题目</li>
						</ul>
					</div>
					<div class="examRecord-box_score">90分</div>
				</div>
				<div class="examRecord-box_bottom">
					<div class="examRecord-box_type">
						<div>练习时间：2：02：03</div>
						<div class="type-flex">练习类型：模型</div>
					</div>
					<div class="examRecord-box_see">查看详情</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"ExamRecord",
		data() {
			return {
				
			}
		},
		methods: {
			onClickLeft() {
				this.$router.go(-1)
			}
		},
	}
</script>

<style>
	.contianer{
		width: 100%;
		min-height: 100vh;
		background: #fff;
	}
	/* 头部 */
	.header{
		width: 100%;
		position: relative;
		font-size: 4vw;
	}
	.header-title{
		text-align: center;
		line-height: 2.5rem;
	}
	.header-retrun{
		height: 2.5rem;
		line-height: 2.5rem;
		position: absolute;
		top: 0;
		left: 0.625rem;
	}
	/* 间距 */
	.margin20{
		width: 100%;
		height: 0.5rem;
		background: #F5F4F9;
	}
	/* 顶部搜索框 */
	.examRecord-top{
		width: 95%;
		margin-right: 5%;
	}
	
	/* 考试记录列表 */
	.examRecord{
		width: 90%;
		margin: 0 auto;
		background: #fff;
		
	}
	.examRecord-box{
		margin-bottom: 0.625rem;
		border-bottom: 1px solid #EBEDEF;
	}
	.examRecord-box_top{
		display: flex;
		justify-content: space-between;
	}
	.examRecord-box_title{
		font-size: 4vw;
		color: #333;
	}
	
	.examRecord-box_bottom{
		margin-top: 0.3125rem;
		width: 100%;
		height: 1.5625rem;
		display: flex;
		justify-content: space-between;
		
	}
	
	.examRecord-box_score{
		font-size: 3.5vw;
		color: #FF795C;
	}
	.examRecord-box_type{
		width: 71%;
		font-size: 3vw;
		color: #999;
		display: flex;
		justify-content: space-between;
	}
	.examRecord-box_see{
		font-size: 3.5vw;
		color: #fff;
		width: 3.5625rem;
		height: 1.125rem;
		border-radius: 0.5625rem;
		background: #FF795C;
		text-align: center;
		line-height: 1.125rem;
	}
	.type-flex{
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/pages/user/ExamRecord.vue